import type { LocationQuery } from '#vue-router'

export const useParseSearchQuery = () => {
  const { map: equimentReferentialMap } = useReferentialMap('vehicle_equipments')

  const flatEquipementList = computed<{ category: string, value: string }[]>(() => Object.values(equimentReferentialMap.value).flat())

  const parseTypesFilter = (query: LocationQuery): SearchFilters['types'] => {
    if (Array.isArray(query.types)) {
      return query.types.reduce<number[]>((acc, value) => {
        if (value) {
          acc.push(parseInt(value))
        }
        return acc
      }, [])
    }
    else if (query.types) {
      return [parseInt(query.types)]
    }
    else {
      return []
    }
  }

  const parseEquipmentsFilter = (query: LocationQuery): SearchFilters['equipments'] => {
    const equipments: SearchFilters['equipments'] = []
    flatEquipementList.value.forEach(({ value }) => {
      if (query[value]) {
        equipments.push(value)
      }
    })
    return equipments
  }

  const parseSearchQuery = (query: LocationQuery): SearchFilters => {
    const filters: SearchFilters = {
      ...initialSearchFiltersFactory(),
      equipments: parseEquipmentsFilter(query),
      types: parseTypesFilter(query),
      // Price
      min_price: queryValueToNumber(query.min_price),
      max_price: queryValueToNumber(query.max_price),
      discount_early: queryValueToBoolean(query.discount_early),
      discount_weekly: queryValueToBoolean(query.discount_weekly),
      // Passengers
      seatbelts: queryValueToNumber(query.seatbelts),
      beds: queryValueToNumber(query.beds),
      // Preference
      km_unlimited: queryValueToBoolean(query.km_unlimited),
      international: queryValueToBoolean(query.international),
      vehicle_height: queryValueToBoolean(query.vehicle_height),
      less_than_five: queryValueToBoolean(query.less_than_five),
      winter_tire: queryValueToBoolean(query.winter_tire),
      winter_chain: queryValueToBoolean(query.winter_chain),
      automatic_gear: queryValueToBoolean(query.automatic_gear),
      licence_type: queryValueToNumber(query.licence_type),
      owner_types: queryValueToNumber(query.owner_types),
      is_ambassador: queryValueToBoolean(query.is_ambassador),
      review_average__gte: queryValueToNumber(query.review_average__gte),
      pets: queryValueToBoolean(query.pets),
      disabled_access: queryValueToBoolean(query.disabled_access),
      instant_booking: queryValueToBoolean(query.instant_booking),
      // Location
      where: queryValueToString(query.where),
      latitude: queryValueToNumber(query.latitude),
      longitude: queryValueToNumber(query.longitude),
      radius: queryValueToNumber(query.radius),
      // Dates
      date_from: queryValueToString(query.date_from),
      date_to: queryValueToString(query.date_to),
      smoking: query.smoking ? queryValueToBoolean(query.smoking) : undefined,
      // Misc
      postgres: queryValueToBoolean(query.postgres),
      marketing_partnership: queryValueToString(query.marketing_partnership),
    }

    return filters
  }

  return { parseSearchQuery }
}
